















































import { Component, Vue, Prop } from "vue-property-decorator";
import { UploadImage } from "@/request/tongue";
@Component({})
export default class ModelTrialShangchuan extends Vue {
  @Prop()
  private message: any;
  private dialogImageUrl = "";
  private dialogVisible = false;
  private fileList: any[] = [];
  private limitedType: any = "";
  private get ossClient() {
    return this.$store.state.ossClient;
  }
  private get ifCompose() {
    return this.$store.state.cdrIfCompose;
  }

  /**
   * @description message双向绑定
   */
  private messageChange() {
    this.$emit("update:message", this.message);
  }
  /**
   * @description 图片上传预处理
   */
  private beforeUpload(file) {
    const arr = file.name.split(".");
    const fileType = arr[arr.length - 1];
    if (this.limitedType.includes(fileType)) {
      return true;
    } else {
      this.$message.warning("只能上传特定类型的文件");
      return false;
    }
  }
  /**
   * @description 上传
   */
  private upload(d) {
    // const uploadFilePath: any = "ds/model/" + d.file.name;
    // this.ossClient
    //   .multipartUpload(uploadFilePath, d.file)
    //   .then((data: any) => {
    //     console.log(data.res);
    //     this.message.info.url = data.res.requestUrls[0].split("?")[0];
    //     this.fileList[0].url = data.res.requestUrls[0].split("?")[0];
    //     this.$forceUpdate();
    //   })
    //   .catch((err: any) => {
    //     console.log(err);
    //   });
    const uploadFilePath: any = "ds/model/" + d.file.name;
    const params: any = {
      type: "model",
      base64_image: "",
    };
    const reader = new FileReader();
    reader.readAsDataURL(d.file);
    reader.onload = (e: any) => {
      params["base64_image"] = e.target["result"];
      console.log(params);
      UploadImage(this, params).then((data: any) => {
        console.log(data);
        this.message.info.url = data.image_url;
        this.fileList[0].url = data.image_url;
        this.$forceUpdate();
      });
    };
  }
  /**
   * @description 文件变化时
   */
  private handleFileChange(file, fileList) {
    this.fileList = fileList;
  }
  /**
   * @description 删除文件
   */
  private handleRemove(file) {
    this.fileList = [];
  }
  /**
   * @description 图片预览
   */
  private handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  /**
   * @description
   */
  private mounted() {
    this.limitedType = ".jpg,.jpeg,.png";
  }
}
